import { MarkerOptions } from '../../components/map/themes/pill-theme.js';

export const DotV2 = ({ themeProps }: { themeProps?: MarkerOptions }) => {
  const coreStyle = {
    width: '8px',
    height: '8px',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25), 0px 1px 1px 0px rgba(0, 0, 0, 0.70)',
    borderRadius: '4px',
  };

  const themeStyle = {
    ...coreStyle,
    backgroundColor: themeProps?.background,
    borderColor: themeProps?.border,
    color: themeProps?.text,
  };

  return <div style={themeStyle} />;
};
